import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { ModalAlert } from '../modal.alert/modal.alert.component';
import { NetworkingContract } from '../../../../services/contrato/networking.contract';
import {
  campanias,
  ContratPeopleResponse,
  documentType,
  QuotationPeopleResponse,
  ContratosActivos,
} from '../../../../models/cotizador/response/model.data.response';
import { SnackBarService } from '../../../../utils/util.SnackBarService';
import { StorageService } from '../../../../utils/util.storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { Base } from '../../base';
import { NetworkingQuotation } from '../../../../services/servicioCotizador/cotizador.service';
import { AuthService } from '../../../../services/security/auth.service';
import { ConsultarAsesorByIDService } from '../../../../services/cotizador-contratante/consultar-asesor-by-id.service';
import { ConsultarAsesorByIDRequest } from '../../../../models/cotizador-contratante/consultar-asesor/request/consultar-asesor-byID-request.model';

NgxSpinnerService;
interface ListHomo {
  linea: { codigo: number; nombre: string }[];
  plan: { codigo: string; nombre: string }[];
  programa: { codigo: string; nombre: string }[];
}

@Component({
  selector: 'app-dialog-contrat',
  templateUrl: './dialog-contrat.component.html',
  styleUrls: ['./dialog-contrat.component.css'],
})
export class DialogContratComponent extends Base {
  typeDocument: Array<documentType> | undefined;

  form = {
    documento: {
      value: null,
      messages: null,
      required: true,
    },
    tipoDocumento: {
      value: null as string | null,
      messages: null,
      required: true,
    },
  };

  listContrato = Array<ContratosActivos>();

  listHomo: ListHomo = {
    linea: [
      { codigo: 1, nombre: 'Medicina Integral' },
      { codigo: 2, nombre: 'Salud Oral' },
    ],
    plan: [
      { codigo: 'A', nombre: 'Asociado' },
      { codigo: 'C', nombre: 'Colectivo' },
      { codigo: 'AS', nombre: 'Asesor' },
      { codigo: 'EM', nombre: 'Empleado' },
    ],
    programa: [
      { codigo: 'CLAS', nombre: 'CLASICO' },
      { codigo: 'ASO', nombre: 'ASOCIADO' },
      { codigo: 'OR12', nombre: 'ORO' },
    ],
  };

  valContratos: ContratosActivos[] = [];
  estado = true;
  opcionesNew: boolean = false;
  opciones = false;
  valPersona: any;
  documento: string = '';
  selectedTipoDocumento: string = '';
  logInfo: any;
  cedula_Asesor: any;
  canalVenta: any = '';

  asesorLogueado: {
    tipo: string;
    nombre: string;
    activo: boolean;
  } | null = null;

  asesorContratante: {
    tipo: string;
    nombre: string;
    activo: boolean;
  } | null = null;

  planBloqueado: string | null = null; // NUEVO: guarda el plan (Cuenta) de la selección activa

  constructor(
    private networking: NetworkingContract,
    private dialog: MatDialog,
    private snackBarService: SnackBarService,
    private storageService: StorageService,
    private renderer: Renderer2,
    private spinner: NgxSpinnerService,
    public dialogRef: MatDialogRef<ModalAlert>,
    public networkingQuotation: NetworkingQuotation,
    private authService: AuthService,
    private consultarAsesorByIDService: ConsultarAsesorByIDService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
    if (data != null) {
      this.listContrato = data.data == null ? [] : this.deduplicateContracts(data.data);
      this.opciones = data.opciones;
    }
  }

  async ngOnInit(): Promise<void> {
    this.logInfo = await this.authService.getAuthInfo();
    console.log('servicio auth documento', this.logInfo);
    const userCC = this.logInfo?.document;
    this.cedula_Asesor = userCC.split('.')[1].trim();

    this.networkingQuotation.getCodigoAsesor(this.cedula_Asesor).subscribe({
      next: (asesor) => {
        // asesor ya es el objeto con todas las propiedades
        this.asesorLogueado = {
          tipo: asesor.CanalVenta,
          nombre: this.invertirNombreCompleto(asesor.NombreCompleto),
          activo: asesor.EstadoPlan === 'Activo',
        };
      },
      error: (err) => console.error(err),
    });

    // Tipo de documento: vacío / "Seleccionar" en inclusión nueva; prefill solo en edición
    const esEdicionInclusion =
      !!this.data?.isEditMode &&
      !!(this.data?.numeroDocumento || '').toString().trim();

    if (esEdicionInclusion) {
      console.log('[Inclusion-Edicion] Rehidratando llaves de identidad del Titular.');
      this.selectedTipoDocumento =
        (this.data.tipoDocumento || '').toString().trim() || 'CC';
      this.documento = (this.data.numeroDocumento || '').toString().trim();
      this.form.tipoDocumento.value = this.selectedTipoDocumento;
      (this.form.documento as any).value = this.documento;
    } else {
      const prefill = (this.data?.tipoDocumento ?? '').toString().trim();
      this.selectedTipoDocumento = prefill;
      this.form.tipoDocumento.value = prefill || null;
    }
    this.networkingQuotation.obtenerTipoDocumento().subscribe({
      next: (tipos) => (this.typeDocument = tipos),
      error: (err) => console.error(err),
    });

    // Inicializar lista de contratos si vienen por data
    if (this.data?.data?.length > 0) {
      this.listContrato = this.deduplicateContracts(this.data.data);
      this.opciones = true;
      this.opcionesNew = true;
      this.valContratos = Array.isArray(this.data.select)
        ? this.deduplicateContracts(this.data.select)
        : [];
    } else {
      this.listContrato = [];
      this.opciones = true; // Oculta el bloque de contratos
      this.opcionesNew = false; // No mostrar contenido inicial
      this.valContratos = [];
    }
   
    const esFlujoInclusionTab = (this.data?.tipoSolicitud ?? localStorage.getItem('tipoSolicitud')) === '2'; 
    if (this.data?.isEditMode && this.documento && esFlujoInclusionTab) { 
      setTimeout(() => { 
        console.log('[Inclusion-Edicion] Ejecutando consulta de contratos vigentes.'); 
        this.buscarPersona(); 
      }, 0); 
    }
  }

  onToggleContrato(item: ContratosActivos, event: any) {
    if (event.target.checked) {
      this.valContratos.push(item);

      // Si es la primera selección, fija el plan que queda "activo"
      if (this.valContratos.length === 1) {
        this.planBloqueado = (item as any).Cuenta ?? null;
      }
    } else {
      this.valContratos = this.valContratos.filter(
        c => c.contra !== item.contra
      );

      // Si ya no queda ningún contrato seleccionado, libera el bloqueo
      if (this.valContratos.length === 0) {
        this.planBloqueado = null;
      }
    }

    console.log("Seleccionados:", this.valContratos);
  }

  invertirNombreCompleto(nombre: string): string {
    if (!nombre) return '';

    const partes = nombre.trim().split(/\s+/);

    if (partes.length <= 2) {
      return nombre; // no hay forma confiable de invertir
    }

    const nombres = partes.slice(2).join(' ');
    const apellidos = partes.slice(0, 2).join(' ');

    return `${nombres} ${apellidos}`;
  }

  searchPeopleOutputSuccessful(data: any): void {
    this.valPersona = data;
    if (data.enMora === '1') {
      this.openDialog(
        this.dialog,
        'Contratante se encuentra en mora con COOMEVA MP.',
        '',
        0,
        (r: boolean) => {},
      );
    }
  }

  searchPeopleOutputFailure(errorCode: number, message?: any): void {
    this.spinner.hide();
    const errorMessage =
      typeof message === 'string' ? message : 'Error desconocido';
    this.openDialog(this.dialog, '', errorMessage, 0, (r: any) => {});
  }

  searchContractOutputSuccessful(data: Array<ContratosActivos>): void {
    this.spinner.hide();

    const dataTemporal: ContratosActivos[] = [];
    // let tienePlanesRestringidos = false;

    for (let i = 0; i < data.length; i++) {
      const contrato = data[i];

      // SOLO QUITAR INACTIVOS (esto SÍ es obligatorio)
      if (contrato.estado !== 'A') {
        continue;
      }

      dataTemporal.push(contrato);
      this.opcionesNew = true;
    }

    const contratosUnicos = this.deduplicateContracts(dataTemporal);

    // Mostrar advertencia SI EXISTE ALGÚN restringido
    // if (tienePlanesRestringidos) {
    //   this.openDialog(
    //     this.dialog,
    //     'Recuerda que las cotizaciones para plan Colectivo, Empleado y Salud Oral las puedes realizar por otro medio',
    //     '',
    //     0,
    //     (r: boolean) => {},
    //   );
    // }

    if (contratosUnicos.length > 0) {
      
      const tipoDocumento = this.form.tipoDocumento.value;
      const documento = this.form.documento.value;

      //TODO: Se comenta la búsqueda de persona porque no es necesaria en este flujo, y además genera un error al no encontrar la persona en el sistema.
      /*if (tipoDocumento && documento) {
        this.networking
          .searchPeople({
            tipoDocumento: tipoDocumento,
            documento: documento,
            codigoTipoPlan: '',
            codigoLineaNegocio: '',
          })
          .subscribe(
            (response: QuotationPeopleResponse) => {
              this.searchPeopleOutputSuccessful(response);
            },
            (error) => {
              console.error('Error en searchPeople:', error);
            },
          );
      }*/
      
     

    } else {
      this.openDialog(
        this.dialog,
        'No se encontraron contratos vigentes asociados al número de documento ingresado.',
        '',
        0,
        (r: boolean) => {},
      );
      return; // Detiene el flujo
    }

    this.listContrato = contratosUnicos;

     const esFlujoInclusion = (this.data?.tipoSolicitud ?? localStorage.getItem('tipoSolicitud')) === '2';
   if (this.data?.isEditMode && esFlujoInclusion) { 
      setTimeout(() => {
        try { 
          const rawInclusion = localStorage.getItem('programas_seleccionados_inclusion'); 
          const rawContratosEdicion = localStorage.getItem('contratos_inclusion_edicion');
          const contratosEdicion: any[] = rawContratosEdicion ? JSON.parse(rawContratosEdicion) : (this.data?.contratosInclusion || []);
          const numerosContratoGuardados = contratosEdicion
            .filter((ci: any) => ci.esSeleccionado === 'S' || ci.esSeleccionado === true || !ci.esSeleccionado)
            .map((ci: any) => (ci.numeroContrato ?? ci.numero_contrato ?? ci.contra ?? '').toString().trim());

          if (this.listContrato.length > 0 && this.valContratos.length === 0) { 
            if (numerosContratoGuardados.length > 0) {
              this.valContratos = this.listContrato.filter(c => 
                numerosContratoGuardados.includes((c.contra ?? '').toString().trim())
              );
            }

            if (this.valContratos.length === 0 && rawInclusion) {
              const programasPrevia = JSON.parse(rawInclusion).map((p: string) => p.trim().toUpperCase()); 
              this.valContratos = this.listContrato.filter(c => { 
                const pCode = (c.cod_programa_afi || (c as any).codigoPrograma || (c as any).programa || (c as any).code || '').toString().trim().toUpperCase();
                return programasPrevia.includes(pCode);
              });
            }

            if (this.valContratos.length > 0) {
              this.planBloqueado = (this.valContratos[0] as any).Cuenta ?? (this.valContratos[0] as any).codigoTipoPlan ?? null;
            }
          } 
        } catch (err) { 
          console.error('[Inclusion-Edicion] Error inyectando checkboxes:', err); 
        } 
      }, 100);
    }
  }

  searchContractOutputFailure(errorCode: number, message?: string): void {
    this.spinner.hide();
    const element = document.getElementById('lblMensaje');
    if (element) {
      element.innerText =
        message &&
        message !== 'undefined' &&
        message !== 'null' &&
        message !== ''
          ? message
          : 'Ha ocurrido un error al buscar el contrato contacte con el administrador';
    } else {
      console.error('Elemento con ID "lblMensaje" no encontrado.');
    }
    this.snackBarService.alert(
      'alert-danger',
      message || 'Error al buscar contrato',
      3000,
      'Cerrar',
    );
  }

  validarTipoAsesor(): void {
    if (!this.asesorLogueado || !this.asesorContratante) {
      this.cerrarModalConSeleccion();
      return;
    }

    // Solo validar si el asesor logueado y el asesor del contrato están activos.
    if (!this.asesorLogueado.activo) {
      this.cerrarModalConSeleccion();
      return;
    }

    if (!this.asesorContratante.activo) {
      this.cerrarModalConSeleccion();
      return;
    }

    const tipoLogueado = this.normalizarTipoAsesor(this.asesorLogueado.tipo);
    const tipoContratante = this.normalizarTipoAsesor(this.asesorContratante.tipo);

    if (tipoLogueado === 'interno' && tipoContratante === 'interno') {
      this.cerrarModalConSeleccion();
      return;
    }

    const nombreAsesor = this.asesorContratante.nombre?.trim() || 'sin nombre disponible';
    const mensaje = `Advertencia: Este usuario ha sido gestionado por el asesor ${tipoContratante} ${nombreAsesor}.`;

    this.openDialog(this.dialog, mensaje, '', 0, () => {
      this.cerrarModalConSeleccion();
    });
  }

  filtrarDocumento(event: any) {
    // Limpiar inmediatamente cualquier carácter que no sea alfanumérico
    const inputElement = event.target;
    let valor = inputElement.value;
    const original = valor;
    valor = valor.replace(/[^a-zA-Z0-9]/g, '');
    
    if (valor !== original) {
      inputElement.value = valor;
      this.documento = valor;
    }
  }

  buscarPersona() {
    this.opcionesNew = false;

    if (!this.documento || !this.selectedTipoDocumento) {
      this.snackBarService.alert(
        'alert-danger',
        'Campos sin diligenciar.',
        3000,
        'Cerrar',
      );
      return;
    }

    this.spinner.show();

    this.networkingQuotation
      .consultarContratos(this.documento, this.selectedTipoDocumento)
      .subscribe({
        next: (response: Array<ContratosActivos>) => {
          this.searchContractOutputSuccessful(response);
        },
        error: (error) => {
          this.searchPeopleOutputFailure(1, error);
        },
      });
  }

  homologar(codigo: string, tipo: string | number) {
    var nombre = '';
    // Verificar que tipo sea uno de los valores esperados
    if (tipo === 'linea' || tipo === 'plan' || tipo === 'programa') {
      var result = this.listHomo[tipo].filter((b) => b.codigo == codigo);
      nombre = result.length > 0 ? result[0].nombre : codigo;
    } else {
      // Manejar el caso donde tipo no es uno de los valores esperados
      console.error(`Tipo inválido: ${tipo}`);
      nombre = codigo;
    }
    return nombre;
  }



continuar(estado: any) {
    this.estado = false;

    if (estado) {

      if (this.valContratos.length === 0) {
        this.snackBarService.alert('alert-danger', 'Seleccione al menos un contrato.');
        return;
      }

      // const programasIds = this.valContratos.map(c => (c as any).cod_programa_afi || (c as any).programa || (c as any).code || c.contra);
      // localStorage.setItem('programas_seleccionados_inclusion', JSON.stringify(programasIds));

      const programasSeleccionados = this.valContratos.map((contrato: any) => ({
        programa: (
          contrato.cod_programa_afi ??
          contrato.programa ??
          contrato.code ??
          ''
        ).toString().trim().toUpperCase(),

        grupoPrograma: (
          contrato.GRUPO_PROGRAMA ??
          contrato.grupo_programa ??
          contrato.grupoPrograma ??
          ''
        ).toString().trim().toUpperCase(),

        numeroContrato: (contrato.contra ?? '').toString().trim()
      }));

      const programasIds = programasSeleccionados
        .map(item => item.programa)
        .filter(Boolean);

      // Se conserva porque el resto del componente espera un string[]
      localStorage.setItem(
        'programas_seleccionados_inclusion',
        JSON.stringify(programasIds)
      );

      // Nueva llave con la relación exacta programa → grupoPrograma
      localStorage.setItem(
        'programas_grupo_inclusion',
        JSON.stringify(programasSeleccionados)
      );

      console.log(
        '[Inclusión] Programas y GRUPO_PROGRAMA seleccionados:',
        programasSeleccionados
      );

      // GUARDAR EN LOCAL STORAGE
      const tipoDocumentoSeleccionado = (
        this.selectedTipoDocumento ??
        this.form.tipoDocumento.value ??
        this.valPersona?.tipoDocumento ??
        this.valPersona?.docu_tipo ??
        this.valPersona?.docu_tipo_benef ??
        ''
      ).toString().trim();

      const numeroDocumentoSeleccionado = (
        this.documento ??
        this.form.documento.value ??
        this.valPersona?.documento ??
        this.valPersona?.docu_nro ??
        this.valPersona?.docu_nro_benef ??
        ''
      ).toString().trim();

      const contratoRadicado = {
        tipoDocumento: tipoDocumentoSeleccionado,
        numeroDocumento: numeroDocumentoSeleccionado,
        contrato: this.valContratos,
        persona: this.valPersona,
        asesor: this.asesorLogueado,
        fecha: new Date().toISOString()
      };

      localStorage.setItem(
        'contrato_radicado',
        JSON.stringify(contratoRadicado)
      );

      console.log(
        'LOCAL STORAGE:',
        JSON.parse(localStorage.getItem('contrato_radicado')!)
      );

      this.resolverYValidarAsesorContrato();

    } else {
      this.dialogRef.close(undefined);
    }
  }


/*
  continuar(estado: any) {
    this.estado = false;

    if (estado) {

      if (this.valContratos.length === 0) {
        this.snackBarService.alert('alert-danger', 'Seleccione al menos un contrato.');
        return;
      }

      // GUARDAR EN LOCAL STORAGE
      const tipoDocumentoSeleccionado = (
        this.selectedTipoDocumento ??
        this.form.tipoDocumento.value ??
        this.valPersona?.tipoDocumento ??
        this.valPersona?.docu_tipo ??
        this.valPersona?.docu_tipo_benef ??
        ''
      ).toString().trim();

      const numeroDocumentoSeleccionado = (
        this.documento ??
        this.form.documento.value ??
        this.valPersona?.documento ??
        this.valPersona?.docu_nro ??
        this.valPersona?.docu_nro_benef ??
        ''
      ).toString().trim();

      const contratoRadicado = {
        tipoDocumento: tipoDocumentoSeleccionado,
        numeroDocumento: numeroDocumentoSeleccionado,
        contrato: this.valContratos,
        persona: this.valPersona,
        asesor: this.asesorLogueado,
        fecha: new Date().toISOString()
      };

      localStorage.setItem(
        'contrato_radicado',
        JSON.stringify(contratoRadicado)
      );

      console.log(
        'LOCAL STORAGE:',
        JSON.parse(localStorage.getItem('contrato_radicado')!)
      );

      this.resolverYValidarAsesorContrato();

    } else {
      this.dialogRef.close(undefined);
    }
  }*/

  private resolverYValidarAsesorContrato(): void {
    const contratoSeleccionado = this.obtenerContratoSeleccionadoParaValidacion();
    const idAsesorContrato = (contratoSeleccionado?.IdAsesor ?? '').toString().trim();

    if (!idAsesorContrato) {
      this.asesorContratante = null;
      this.validarTipoAsesor();
      return;
    }

    const request: ConsultarAsesorByIDRequest = {
      nombreClave: 'getSpCotConsultarAsesorPorID',
      jsonParametros: JSON.stringify({
        prm_id_asesor: idAsesorContrato,
      }),
    };

    this.consultarAsesorByIDService.consultarAsesorByID(request).subscribe({
      next: (response) => {
        const asesor = Array.isArray(response?.data) ? response.data[0] : null;
        const nombreContrato =
          (asesor?.NombreCompleto ?? '').toString().trim() ||
          (contratoSeleccionado?.nombreAsesor ?? contratoSeleccionado?.nombre_asesor ?? '').toString().trim();
        const tipoContrato =
          (asesor?.CanalVenta ?? asesor?.TipoAsesor ?? '').toString().trim() ||
          (contratoSeleccionado?.CanalVenta ?? contratoSeleccionado?.canalVentaAsesorPoblacion ?? '').toString().trim();
        const estadoPlan = (asesor?.EstadoPlan ?? '').toString().trim().toUpperCase();

        this.asesorContratante = {
          tipo: tipoContrato,
          nombre: this.invertirNombreCompleto(nombreContrato),
          activo: estadoPlan === 'ACTIVO',
        };
        this.validarTipoAsesor();
      },
      error: (err) => {
        console.error('Error al obtener asesor del contrato por ID', err);
        const nombreContrato = (
          contratoSeleccionado?.nombreAsesor ??
          contratoSeleccionado?.nombre_asesor ??
          contratoSeleccionado?.nombreAsesorPoblacion ??
          ''
        ).toString().trim();
        const tipoContrato = (
          contratoSeleccionado?.CanalVenta ??
          contratoSeleccionado?.canalVentaAsesorPoblacion ??
          ''
        ).toString().trim();

        this.asesorContratante = {
          tipo: tipoContrato,
          nombre: this.invertirNombreCompleto(nombreContrato),
          activo: true,
        };
        this.validarTipoAsesor();
      },
    });
  }

  private obtenerContratoSeleccionadoParaValidacion(): ContratosActivos | null {
    if (Array.isArray(this.valContratos) && this.valContratos.length > 0) {
      return this.valContratos[0];
    }
    return null;
  }

  private normalizarTipoAsesor(tipo: string): 'interno' | 'externo' {
    const valor = (tipo ?? '').toString().trim().toLowerCase();
    return valor === 'interno' ? 'interno' : 'externo';
  }

  private deduplicateContracts(contracts: ContratosActivos[]): ContratosActivos[] {
    const unique = new Map<string, ContratosActivos>();

    for (const contrato of contracts) {
      const key = contrato.contra?.toString().trim();
      if (!key) {
        continue;
      }

      if (!unique.has(key)) {
        unique.set(key, contrato);
        continue;
      }

      const current = unique.get(key);
      if (current) {
        const currentAdvisor = (current.nombreAsesor || current.nombre_asesor || '').toString().trim();
        const newAdvisor = (contrato.nombreAsesor || contrato.nombre_asesor || '').toString().trim();
        if (!currentAdvisor && newAdvisor) {
          unique.set(key, contrato);
        }
      }
    }

    return Array.from(unique.values());
  }

  private cerrarModalConSeleccion(): void {
    this.dialogRef.close({
      select: this.valContratos,
      all: this.listContrato,
      persona: this.valPersona,
    });
  }

  // Dentro de DialogContratComponent
  onSelect(obj: any) {
    this.valContratos = obj;
  }

  isItemSelected(item: ContratosActivos): boolean {
    return this.valContratos.some(c => c.contra === item.contra);
  }

  // Se agreaga como nueva regla para la selección de contratos en inclusiones por tipo de plan
  isItemDisabled(item: ContratosActivos): boolean {
    if (this.planBloqueado === null) {
      return false; // Nada bloqueado todavía, todos habilitados
    }
    // Deshabilita los registros que tengan un plan (Cuenta) distinto al bloqueado,
    // Pero nunca deshabilites uno que ya está seleccionado (para poder desmarcarlo)
    return (
      (item as any).Cuenta !== this.planBloqueado && !this.isItemSelected(item)
    );
  }


}
